import {Component, inject} from '@angular/core';
import {ToastService} from '../../services/toast/toast.service';

/**
 * Componente overlay per la visualizzazione di messaggi toast floating.
 * Va inserito una sola volta nel layout radice dell'applicazione.
 */
@Component({
  selector: 'app-toast',
  standalone: true,
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
})
export class ToastComponent {
  protected readonly toastService = inject(ToastService);
}
